import { render, staticRenderFns } from "./Photogrammetry.vue?vue&type=template&id=9ff84d18&scoped=true"
import script from "./Photogrammetry.vue?vue&type=script&lang=js"
export * from "./Photogrammetry.vue?vue&type=script&lang=js"
import style0 from "./Photogrammetry.vue?vue&type=style&index=0&id=9ff84d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff84d18",
  null
  
)

export default component.exports